// HL custom: cart drawer add-on checkbox (snippets/hl-cart-addon.liquid).
// Checked adds one of the variant, unchecked removes every unit of it,
// then the drawer re-renders the same way gift-wrapping.js does.
if (!customElements.get('hl-cart-addon')) {
  customElements.define('hl-cart-addon', class HlCartAddon extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.hl-cart-addon__checkbox');
      if (!this.checkbox) return;
      this.onChange = this.onChange || ((event) => this.update(event.target.checked));
      this.checkbox.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      if (this.checkbox) this.checkbox.removeEventListener('change', this.onChange);
    }

    update(checked) {
      const miniCart = document.querySelector('mini-cart');
      this.classList.add('is-loading');
      this.checkbox.disabled = true;

      const body = JSON.stringify({
        updates: { [this.dataset.variantId]: checked ? 1 : 0 },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((response) => {
          if (document.body.classList.contains('template-cart')) {
            window.location.href = theme.routes.cart_url;
            return;
          }
          if (response.status) throw new Error(response.description || response.message);
          if (miniCart) miniCart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
          this.checkbox.checked = !checked;
        })
        .finally(() => {
          this.classList.remove('is-loading');
          this.checkbox.disabled = false;
        });
    }

    getSectionsToRender() {
      return [
        { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
      ];
    }
  });
}
